<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              prop="all_time"
              :hint="$t('SegmentationSettings_Field_AllTime_Hint')"
            >
              <toggle
                v-model="model.all_time"
                :text="$t('SegmentationSettings_Field_AllTime')"
              />
            </rest-form-item>

            <rest-form-item
              prop="trino"
              :label="$t('SegmentationSettings_Field_Trino')"
              :hint="$t('SegmentationSettings_Field_Trino_Hint')"
            >
              <el-select v-model="model.trino">
                <el-option :value="0" label="Disabled" />
                <el-option :value="1" label="Enabled" />
                <el-option
                  :value="2"
                  label="Partially Enabled (Counts & Rolling Segments)"
                />
              </el-select>
            </rest-form-item>

            <rest-form-item
              prop="sampling_index"
              :hint="$t('SegmentationSettings_Field_SamplingIndex_Hint')"
            >
              <toggle
                v-model="model.sampling_index"
                :text="$t('SegmentationSettings_Field_SamplingIndex')"
              />
            </rest-form-item>

            <rest-form-item
              prop="rolling_segments"
              :hint="$t('SegmentationSettings_Field_RollingSegments_Hint')"
            >
              <toggle
                v-model="model.rolling_segments"
                :text="$t('SegmentationSettings_Field_RollingSegments')"
              />
            </rest-form-item>
            <rest-form-item
              prop="max_rolling_segments_count"
              :label="$t('SegmentationSettings_Field_RollingSegments_MaxCount')"
            >
              <el-input-number
                :disabled="!model.rolling_segments"
                v-model="model.max_rolling_segments_count"
                :min="1"
                :max="20"
              />
            </rest-form-item>

            <rest-form-item
              prop="sampling"
              :hint="$t('SegmentationSettings_Field_Sampling_Hint')"
            >
              <el-tooltip
                effect="light"
                :content="$t('ProjectSettings_Tooltip_Sampling')"
                placement="right"
              >
                <toggle
                  v-model="model.sampling"
                  :text="$t('SegmentationSettings_Field_Sampling')"
                />
              </el-tooltip>
            </rest-form-item>

            <rest-form-item
              prop="sampling_size"
              v-if="model.sampling"
              :label="$t('SegmentationSettings_Field_SamplingSize')"
              :hint="$t('SegmentationSettings_Field_SamplingSize_Hint')"
            >
              <el-input v-model="model.sampling_size" />
            </rest-form-item>
            <rest-form-item
              prop="json_attributes"
              :label="$t('SegmentationSettings_Field_JsonAttributes')"
              :hint="$t('SegmentationSettings_Field_JsonAttributes_Hint')"
            >
              <el-select v-model="model.json_attributes">
                <el-option :value="0" label="Post-migration" />
                <el-option :value="1" label="Transition" />
                <el-option :value="2" label="Pre-migration" />
              </el-select>
            </rest-form-item>

            <rest-form-item
              prop="json_aggregates"
              :label="$t('SegmentationSettings_Field_JsonAggregates')"
              :hint="$t('SegmentationSettings_Field_JsonAggregates_Hint')"
            >
              <el-select v-model="model.json_aggregates">
                <el-option :value="0" label="Post-migration" />
                <el-option :value="1" label="Transition" />
                <el-option :value="2" label="Pre-migration" />
              </el-select>
            </rest-form-item>

            <rest-form-item
              prop="unenforced_attribute_types"
              :label="$t('SegmentationSettings_Field_UnenforcedAttributeTypes')"
              :hint="
                $t('SegmentationSettings_Field_UnenforcedAttributeTypes_Hint')
              "
            >
              <el-select v-model="model.unenforced_attribute_types">
                <el-option
                  :value="0"
                  label="Automatically converted to string"
                />
                <el-option :value="1" label="Can be created via API only" />
                <el-option :value="2" label="Can be created via API and UI" />
              </el-select>
            </rest-form-item>

            <rest-form-item
              prop="campaign_prepare_interval"
              :label="$t('SegmentationSettings_Field_CampaignPrepareInterval')"
              :hint="
                $t('SegmentationSettings_Field_CampaignPrepareInterval_Hint')
              "
            >
              <el-input
                v-model="model.campaign_prepare_interval"
                placeholder="None"
              >
                <template slot="append">minutes upfront</template>
              </el-input>
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import Toggle from '@/common/components/form/Toggle'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'SegmentationSettingsPage',

  components: {
    Toggle,
    RestFormPage,
    RestFormItem,
    FormSection
  },

  data() {
    return {
      model: null
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``,
        params: {
          fields:
            'all_time,trino,rolling_segments,sampling,sampling_size,sampling_index,campaign_prepare_interval,json_attributes,json_aggregates,unenforced_attribute_types,max_rolling_segments_count'
        },
        handler: data => {
          this.model = data
        }
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: ``,
        params: {
          data: this.model
        }
      })
    },

    readonly() {
      return !this.$isRole('admin')
    }
  },
  methods: {
    afterSave(res, loading) {
      this.$store.dispatch('reloadProjectConfig').then(loading())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/SegmentationSettingsPage.vue